const CAPTCHA_ERRORS = new Set([
  "captcha_required",
  "captcha_failed",
  "captcha_unavailable",
]);

export const CAPTCHA_REQUIRED_MESSAGE = "사람 확인을 완료해 주세요.";
export const CAPTCHA_REQUIRED_MESSAGE_EN = "Please complete the verification.";

export async function getCaptchaErrorMessage(
  response: Response,
  locale: "ko" | "en" = "ko",
): Promise<string | null> {
  if (response.status !== 400 && response.status !== 502) return null;

  const body = (await response.json().catch(() => null)) as {
    error?: unknown;
  } | null;
  if (typeof body?.error !== "string" || !CAPTCHA_ERRORS.has(body.error)) {
    return null;
  }
  if (body.error === "captcha_unavailable") {
    return locale === "en"
      ? "Verification is temporarily unavailable. Please try again later."
      : "사람 확인 서비스에 연결할 수 없어요. 잠시 후 다시 시도해 주세요.";
  }
  return locale === "en" ? CAPTCHA_REQUIRED_MESSAGE_EN : CAPTCHA_REQUIRED_MESSAGE;
}
